import { useEffect, useMemo, useState } from "react";
import { getAuditFilters } from "../../../services/apis/auditApis";

const EMPTY_OPTIONS = { apps: [], workflows: [], activities: [], instances: [] };

// Cascading picker options sourced from the audit data itself, scoped to the
// current org: apps of the org; workflows/activities/instances narrow when
// app_id / wf_id are set.
const useAuditFilters = (appId, wfId, orgId) => {
  const [options, setOptions] = useState(EMPTY_OPTIONS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const response = await getAuditFilters({
          app_id: appId || undefined,
          wf_id: wfId || undefined,
          org_id: orgId || undefined
        });
        if (!cancelled) setOptions(response?.data || EMPTY_OPTIONS);
      } catch (error) {
        console.error("Failed to fetch audit filters:", error);
        if (!cancelled) setOptions(EMPTY_OPTIONS);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchOptions();
    return () => {
      cancelled = true;
    };
  }, [appId, wfId, orgId]);

  const appNameById = useMemo(() => {
    const map = {};
    (options.apps || []).forEach((a) => {
      map[a.app_id] = a.app_name;
    });
    return map;
  }, [options.apps]);

  return { options, appNameById, loading };
};

export default useAuditFilters;
